import React from "react";
import MListSidebarFilterGroup from "../mlist/MListSidebarFilterGroup";

export default function ResourcesSidebar({
  categoryIds,
  onCategoryIdsChange,
  showFeaturedOnly,
  onShowFeaturedOnlyChange,
  categories,
  onClearAll,
  hasActiveFilters,
}) {
  const categoryOptions = categories.map((cat) => ({
    id: cat,
    label: cat,
  }));

  return (
    <aside className="twentytwentysix-content__mlist-sidebar" aria-label="Filter articles">
      {hasActiveFilters && (
        <button
          type="button"
          className="twentytwentysix-content__filter-pill twentytwentysix-content__mlist-sidebar-clear"
          onClick={onClearAll}
        >
          Clear all filters
        </button>
      )}

      <MListSidebarFilterGroup
        title="Topics"
        options={categoryOptions}
        selectedIds={categoryIds}
        onChange={onCategoryIdsChange}
        ariaLabel="Article topics"
      />

      <div
        className="twentytwentysix-content__mlist-sidebar-facet-group"
        role="group"
        aria-label="Featured"
      >
        <p className="twentytwentysix-content__mlist-sidebar-title">Featured</p>
        <div className="twentytwentysix-content__mlist-sidebar-facet-options">
          <label className="twentytwentysix-content__mlist-sidebar-check">
            <input
              type="checkbox"
              checked={showFeaturedOnly}
              onChange={(e) => onShowFeaturedOnlyChange(e.target.checked)}
            />
            <span>Show featured only</span>
          </label>
        </div>
      </div>
    </aside>
  );
}

